import { useEffect, useState, useCallback, useMemo } from "react";
import Slider from "react-slick";
import sanityClient from "../../sanityClient";

export default function HomeMedia() {
  const [logos, setLogos] = useState([]);

  const fetchLogos = useCallback(() => {
    sanityClient
      .fetch(
        `*[_type == "mediaLogo" && !defined(deletedAt)] | order(createdAt desc) {
          title,
          "logoUrl": logoImage.asset->url,
          url
        }`
      )
      .then((data) => {
        if (data && data.length > 0) setLogos(data);
      })
      .catch(console.error);
  }, []);

  useEffect(() => {
    fetchLogos();
  }, [fetchLogos]);

  const sliderSettings = useMemo(() => ({
    dots: false,
    arrows: false,
    slidesToShow: 5,
    infinite: true,
    autoplay: true,
    slidesToScroll: 1,
    pauseOnHover: false,
    cssEase: "linear",
    autoplaySpeed: 0,
    speed: 6000,
    responsive: [
      { breakpoint: 991, settings: { slidesToShow: 4 } },
      { breakpoint: 767, settings: { slidesToShow: 3 } },
      { breakpoint: 599, settings: { slidesToShow: 2 } },
    ],
  }), []);

  return (
    <section className="home-media">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="homemedia-box">
              <h4 className="heading center-heading">In the Media</h4>
              <div className="shape-divider">
                <img src="/assets/home/element.png" alt="vector" loading="lazy" />
              </div>

              {logos.length > 0 ? (
                <Slider className="medialogo-slider" {...sliderSettings}>
                  {logos.map((logo, index) => (
                    <a href={logo.url} target="_blank" rel="noopener noreferrer" key={index}>
                      <img src={logo.logoUrl} alt={logo.title} loading="lazy" />
                    </a>
                  ))}
                </Slider>
              ) : (
                <p className="text-center">No media logos available</p>
              )}

              <img
                src="/assets/home/white-curve.svg"
                className="media-shape-1"
                alt="shape"
                loading="lazy"
              />
              <img
                src="/assets/home/white-curve.svg"
                className="media-shape-2"
                alt="shape"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
